// Service configuration for all dashboard services with unique Grafana dashboards
export const servicesConfig = {
  'service-health': {
    key: 'service-health',
    name: 'Service Health',
    description: 'Monitor System Status and Availability',
    route: '/service/service-health',
    grafanaDashboard: {
      id: 'service-health-dashboard',
      title: 'Service Health Monitoring Dashboard',
      apiKey: 'serviceHealth', // Maps to backend API key
      embedId: 'service-health-embed',
      description: 'Real-time monitoring of system health, uptime, and availability metrics'
    },
    relatedActions: [
      {
        title: 'System Status',
        onClick: () => console.log('Navigate to System Status')
      },
      {
        title: 'Availability Metrics',
        onClick: () => console.log('Navigate to Availability Metrics')
      },
      {
        title: 'Performance Overview',
        onClick: () => console.log('Navigate to Performance Overview')
      }
    ]
  },
  'cases': {
    key: 'cases',
    name: 'Incidents',
    description: 'View and Manage Support Cases',
    route: '/service/cases',
    grafanaDashboard: {
      id: 'cases-dashboard',
      title: 'Support Cases Analytics Dashboard',
      apiKey: 'incidents', // Maps to backend API key
      embedId: 'cases-embed',
      description: 'Track case volumes, resolution times, and support team performance'
    },
    relatedActions: [
      {
        title: 'Open Cases',
        onClick: () => console.log('Navigate to Open Cases')
      },
      {
        title: 'Case Analytics',
        onClick: () => console.log('Navigate to Case Analytics')
      },
      {
        title: 'Support Metrics',
        onClick: () => console.log('Navigate to Support Metrics')
      }
    ]
  },
  'changes': {
    key: 'changes',
    name: 'Changes',
    description: 'Track System Changes and Updates',
    route: '/service/changes',
    grafanaDashboard: {
      id: 'changes-dashboard',
      title: 'Change Management Dashboard',
      apiKey: 'changes', // Maps to backend API key
      embedId: 'changes-embed',
      description: 'Track change requests, approvals, and implementation status'
    },
    relatedActions: [
      {
        title: 'Change Calendar',
        onClick: () => console.log('Navigate to Change Calendar')
      },
      {
        title: 'Change Success Rate',
        onClick: () => console.log('Navigate to Change Success Rate')
      },
      {
        title: 'Emergency Changes',
        onClick: () => console.log('Navigate to Emergency Changes')
      }
    ]
  },
  'sla-reporting': {
    key: 'sla-reporting',
    name: 'SLA and Reporting',
    description: 'Service Level Agreements and Reports',
    route: '/service/sla-reporting',
    grafanaDashboard: {
      id: 'sla-reporting-dashboard',
      title: 'SLA & Compliance Reporting Dashboard',
      apiKey: 'serviceLevelAgreementAndReporting', // Maps to backend API key
      embedId: 'sla-reporting-embed',
      description: 'Monitor SLA compliance, breach incidents, and performance against targets'
    },
    relatedActions: [
      {
        title: 'Projects',
        onClick: () => console.log('Navigate to Projects')
      },
      {
        title: 'Incidents',
        onClick: () => console.log('Navigate to Incidents')
      },
      {
        title: 'Changes',
        onClick: () => console.log('Navigate to Changes')
      }
    ]
  },
  'environment-performance': {
    key: 'environment-performance',
    name: 'Service Requests',
    description: 'System Performance Monitoring',
    route: '/service/environment-performance',
    grafanaDashboard: {
      id: 'environment-performance-dashboard',
      title: 'Environment & Performance Metrics Dashboard',
      apiKey: 'serviceRequests', // Maps to backend API key
      embedId: 'environment-performance-embed',
      description: 'Monitor system resources, performance metrics, and infrastructure health'
    },
    relatedActions: [
      {
        title: 'System Performance',
        onClick: () => console.log('Navigate to System Performance')
      },
      {
        title: 'Environment Health',
        onClick: () => console.log('Navigate to Environment Health')
      },
      {
        title: 'Resource Utilization',
        onClick: () => console.log('Navigate to Resource Utilization')
      }
    ]
  },
  'alerts-aiops': {
    key: 'alerts-aiops',
    name: 'Alerts and AIOPs',
    description: 'AI-Powered Alerts and Operations',
    route: '/service/alerts-aiops',
    grafanaDashboard: {
      id: 'alerts-aiops-dashboard',
      title: 'AI Operations & Alerts Dashboard',
      apiKey: null, // No API mapping available yet
      fallbackUrl: 'https://grafana.company.com/d/alerts-aiops',
      embedId: 'alerts-aiops-embed',
      description: 'AI-powered incident detection, alert correlation, and operational insights'
    },
    relatedActions: [
      {
        title: 'Active Alerts',
        onClick: () => console.log('Navigate to Active Alerts')
      },
      {
        title: 'AI Insights',
        onClick: () => console.log('Navigate to AI Insights')
      },
      {
        title: 'Alert Analytics',
        onClick: () => console.log('Navigate to Alert Analytics')
      }
    ]
  },
  'problems-rca': {
    key: 'problems-rca',
    name: 'Problems and RCA',
    description: 'Root Cause Analysis and Problem Tracking',
    route: '/service/problems-rca',
    grafanaDashboard: {
      id: 'problems-rca-dashboard',
      title: 'Problem Management & RCA Dashboard',
      apiKey: 'problemsAndRootCauseAnalysis', // Maps to backend API key
      embedId: 'problems-rca-embed',
      description: 'Track problems, root cause analysis progress, and resolution patterns'
    },
    relatedActions: [
      {
        title: 'Problem Management',
        onClick: () => console.log('Navigate to Problem Management')
      },
      {
        title: 'RCA Reports',
        onClick: () => console.log('Navigate to RCA Reports')
      },
      {
        title: 'Incident Analysis',
        onClick: () => console.log('Navigate to Incident Analysis')
      }
    ]
  },
  'projects': {
    key: 'projects',
    name: 'Projects',
    description: 'Project Management and Tracking',
    route: '/service/projects',
    grafanaDashboard: {
      id: 'projects-dashboard',
      title: 'Project Management Dashboard',
      apiKey: null, // No API mapping available yet
      fallbackUrl: 'https://grafana.company.com/d/projects',
      embedId: 'projects-embed',
      description: 'Track project progress, milestones, resource allocation, and deliverables'
    },
    relatedActions: [
      {
        title: 'Project Status',
        onClick: () => console.log('Navigate to Project Status')
      },
      {
        title: 'Resource Allocation',
        onClick: () => console.log('Navigate to Resource Allocation')
      },
      {
        title: 'Project Timeline',
        onClick: () => console.log('Navigate to Project Timeline')
      }
    ]
  },
  'governance': {
    key: 'governance',
    name: 'Governance',
    description: 'Compliance and Governance Oversight',
    route: '/service/governance',
    grafanaDashboard: {
      id: 'governance-dashboard',
      title: 'Governance & Compliance Dashboard',
      apiKey: null, // No API mapping available yet
      fallbackUrl: 'https://grafana.company.com/d/governance',
      embedId: 'governance-embed',
      description: 'Monitor compliance status, audit activities, and governance metrics'
    },
    relatedActions: [
      {
        title: 'Compliance Overview',
        onClick: () => console.log('Navigate to Compliance Overview')
      },
      {
        title: 'Risk Assessment',
        description: 'Review system audit logs and trails',
        onClick: () => console.log('Navigate to Risk Assessment')
      },
      {
        title: 'Audit Reports',
        onClick: () => console.log('Navigate to Audit Reports')
      }
    ]
  },
  'asset-environment': {
    key: 'asset-environment',
    name: 'Asset & Environment',
    description: 'Asset inventory and environment coverage insights (coming soon)',
    route: '/service/asset-environment',
    grafanaDashboard: {
      id: 'asset-environment-dashboard',
      title: 'Asset & Environment Dashboard',
      apiKey: null, // No API mapping available yet
      fallbackUrl: 'https://grafana.company.com/d/asset-environment',
      embedId: 'asset-environment-embed',
      description: 'Monitor asset inventory, environment status, and compliance metrics'
    },
    relatedActions: [
      {
        title: 'Compliance Overview',
        onClick: () => console.log('Navigate to Compliance Overview')
      },
      {
        title: 'Risk Assessment',
        description: 'Review system audit logs and trails',
        onClick: () => console.log('Navigate to Risk Assessment')
      },
      {
        title: 'Audit Reports',
        onClick: () => console.log('Navigate to Audit Reports')
      }
    ]
  },
  'customer-management': {
    key: 'customer-management',
    name: '360 Customer View',
    description: 'Comprehensive customer service management and analytics',
    route: '/service/customer-management',
    grafanaDashboard: {
      id: 'customer-management-dashboard',
      title: '360 Customer View Dashboard',
      apiKey: 'customerServiceManagement',
      embedId: 'customer-management-embed',
      description: 'Unified view of customer interactions, service history, and engagement metrics'
    },
    relatedActions: [
      {
        title: 'Customer Insights',
        onClick: () => console.log('Navigate to Customer Insights')
      },
      {
        title: 'Service History',
        onClick: () => console.log('Navigate to Service History')
      },
      {
        title: 'Engagement Metrics',
        onClick: () => console.log('Navigate to Engagement Metrics')
      }
    ]
  }
};

// Get service configuration by key
export const getServiceConfig = (serviceKey) => {
  return servicesConfig[serviceKey] || null;
};

// Get all services as an array
export const getAllServices = () => {
  return Object.values(servicesConfig);
};

// Get service route by key
export const getServiceRoute = (serviceKey) => {
  const config = getServiceConfig(serviceKey);
  return config ? config.route : null;
};